'use client';

import {
  createFormAttributionHandler,
  createFormSubmissionHandler,
} from '../core';
import { useUtag } from '../hooks';
import { FormAttributionInteraction } from '../types';

import type { FC } from 'react';

export const TrackFormAttribution: FC = () => {
  useUtag(() => {
    const handleChange = createFormAttributionHandler(
      FormAttributionInteraction.Fill,
    );
    const handleSubmit = createFormSubmissionHandler();

    document.addEventListener('change', handleChange);
    document.addEventListener('submit', handleSubmit);

    return () => {
      document.removeEventListener('change', handleChange);
      document.removeEventListener('submit', handleSubmit);
    };
  }, []);

  return null;
};
